export enum EmployeeRole {
  NO_ACCESS = 'NO_ACCESS',
  VIEWER = 'VIEWER',
  ADMIN = 'ADMIN',
}

const employeeRoles = [
  [EmployeeRole.NO_ACCESS, '-'],
  [EmployeeRole.VIEWER, 'Viewer'],
  [EmployeeRole.ADMIN, 'Admin'],
] as const;

export const employeeRolesMap: Map<EmployeeRole, string> = new Map(employeeRoles);
export const reversedEmployeeRolesMap: Map<string, EmployeeRole> = new Map(employeeRoles.map(([k, v]) => [v, k]));


export const EMPLOYEE_ROLE_DISPLAY_MAP = new Map<EmployeeRole, string>([
  [EmployeeRole.NO_ACCESS, '-'],
  [EmployeeRole.VIEWER, 'User'],
  [EmployeeRole.ADMIN, 'Admin'],
]);
